<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">

      <div class="p-grid p-nogutter">
        <div class="p-col">
          <h2>
            {{$t('factory.title')}}
          </h2>
        </div>
        <div class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button v-if="role.includes('FACTORY')" :label="$t('factory.create_button')" @click="createDialog()" icon="irinox-icon-button pi pi-plus" iconPos="left" />
        </div>
      </div>
        <div class="irinox-form factory-form" >
          <TabView lazy :activeIndex="'appliances'==uxData['factory.tab'] ? 1 : 0">
            <TabPanel :header="$t('factory.tab_users')">
              <Users/>
            </TabPanel>
            <TabPanel :header="$t('factory.tab_appliances')">
              <Appliances/>
            </TabPanel>
          </TabView>
        </div>
		</div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('factory.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('factory.create_dialog.success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

    <Dialog :visible="dialog.create" class="irinox-dialog-light" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              >
    
      <template #header>
        <img src="assets/irinox/icons/arrow_back.svg" @click="dialog.create = false" :alt="$t('common.arrow_left')"/>
        <div>{{$t('factory.create_dialog.title')}}</div>
      </template>

      <div class="irinox-dialog-light-content layout-content">
        <div class="irinox-form p-pt-2">
          <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col-12">
                  <label for="serialNumber">{{$t('factory.create_dialog.serialNumber')}}</label>
                  <!-- <InputText type="text" v-model="createData.serialNumber" 
                    :placeholder="$t('factory.create_dialog.serialNumber_ph')"
                    :class="{'p-invalid': (!createData.serialNumber || !regexSerialNumber.test(createData.serialNumber)) && submitted}"
                    /> -->
                  <InputMask v-model="createData.serialNumber" 
                    :placeholder="$t('factory.create_dialog.serialNumber_ph')"
                    mask="999999999M"
                    :class="{'p-invalid': (!createData.serialNumber || !regexSerialNumber.test(createData.serialNumber)) && submitted}" id="serialNumber"
                    />
              </div>
              <div class="p-field p-col-12">
                <label for="brandName">{{$t('factory.create_dialog.brand')}}</label>
                <InputText type="text" v-model="createData.brandName" 
                :disabled="true" id="brandName"
                />
              </div>
              <div class="p-field p-col-12">
                  <label>{{$t('factory.create_dialog.domain')}}</label>
                  <Dropdown v-model="createData.domain" :options="domains" optionLabel="name" optionValue="code"
                    :placeholder="$t('factory.create_dialog.domain_ph')"
                    :class="{'p-invalid': !createData.domain && submitted}"
                    />
              </div>
              <div class="p-field p-col-12">
                  <label>{{$t('factory.create_dialog.gamma')}}</label>
                  <Dropdown v-model="createData.gamma" :options="gamme" optionLabel="name" optionValue="code"
                    :placeholder="$t('factory.create_dialog.gamma_ph')"
                    :class="{'p-invalid': !createData.gamma && submitted}"
                    />
              </div>
              <div v-if="createData.gamma" class="p-field p-col-12">
                  <label>{{$t('factory.create_dialog.model')}}</label>
                  <Dropdown v-model="createData.modelId" :options="filteredModels" optionLabel="name" optionValue="code"
                    :filter="true"
                    :placeholder="$t('factory.create_dialog.model_ph')"
                    :class="{'p-invalid': !createData.modelId && submitted}"
                    />
              </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button :label="$t('factory.create_dialog.button')" style="width: fit-content" @click="create()"/>
      </template>

  </Dialog>

	</div>

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import AccountService from '../../service/AccountService';
import ReportService from '../../service/ReportService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import Users from './Users.vue';
import Appliances from './Appliances.vue';
import { mapGetters } from 'vuex';

export default {
  
    components: {
      IrinoxDialogDark,
      Appliances,
      Users
    },
    data() {
        return {
          models: [],
          gamme: [],
          domains: [],
          filteredModels: [],
          submitted: false,
          createData: {},
          dialog: {
            create: false,
            error: false,
            success: false,
          },
          regexSerialNumber: /^(1[5-9]|[2-4][0-9]|50)(0[1-9]|1[0-2])(\d{5})M$/
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          role: 'userdata/role',
          uxData: 'preferences/uxData',
        }),
    },
    created() {
      this.applianceService = new ApplianceService();
      this.accountService = new AccountService();
      this.reportService = new ReportService();
      this.emptyData();
    },
    mounted() {
      this.loadDomains();
    },
    watch: {
      'createData.gamma': 'fillModels'
    },
    methods: {
      emptyData() {
        this.createData = {
            serialNumber: null,
            brandName: 'IRINOX',
            domain: null,
            gamma: null,
            modelId: null,
          };
      },
      loadModels() {
        this.models = [];
        this.gamme = [];
        this.filteredModels = [];
        this.reportService.models(this.personaltoken)
          .then((data) => {
            this.models = data;
            let gs = [];
            for(let i=0; i<this.models.length; i++) {
              gs.push({ code: this.models[i].gamma, name: this.models[i].gamma });
            }
            this.gamme = this.$functions.uniqByKeepFirst(gs, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
          })
          .catch(error => {
            console.error("ERROR " + error);
            this.models = [];
            this.gamme = [];
            this.filteredModels = [];
            this.dialog.error = true;
          });
      },
      loadDomains() {
        this.domains = [];
        this.accountService.getAllDomains(this.personaltoken)
          .then((data) => {
            if(data.code=="200") {
              let ds = [];
              for(let i=0; i<data.body.length; i++) {
                ds.push({ code: data.body[i].domainId, name: data.body[i].domainName });
              }
              this.domains = this.$functions.uniqByKeepFirst(ds, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
            }
          })
          .catch(error => {
            console.error("ERROR " + error);
            this.domains = [];
            this.dialog.error = true;
          });
      },
      fillModels() {
        this.createData.modelId = null;
        let ms = [];
        for(let i=0; i<this.models.length; i++) {
          if(this.models[i].gamma === this.createData.gamma) {
            ms.push({ 
              code: this.models[i].modelId, 
              name: this.models[i].gamma + " " + this.models[i].name + " " + this.models[i].accessory 
            });
          }
        }
        this.filteredModels = this.$functions.uniqByKeepFirst(ms, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
      },
      createDialog() {
        this.loadModels();
        this.submitted = false;
        this.emptyData();
        this.dialog.create = true;
      },
      create() {
        this.submitted = true;
        if(!this.createData.serialNumber || !this.createData.brandName || 
            !this.createData.domain || !this.createData.gamma || !this.createData.modelId) {
          return;
        }

        if (!this.regexSerialNumber.test(this.createData.serialNumber)) {
          return;
        }

        this.dialog.create = false;
        this.applianceService.createAppliance(this.personaltoken, this.createData)
          .then((res) => {
            let contentType = res.headers["content-type"];
            if(contentType === 'application/octet-stream') {
              //Download zip
              this.emptyData();
              this.dialog.success = true;
              let filename = "certificates_"+this.createData.serialNumber+".zip";
              let contentDisposition = res.headers["content-disposition"];
              if(contentDisposition) {
                filename = contentDisposition.replace(/.*filename="(.*)".*/g,"$1");
              }
              let blob=new Blob([res.data], {type: contentType});
              let link=document.createElement('a');
              link.href=window.URL.createObjectURL(blob);
              link.download=filename;
              link.click();
            } else {
              this.dialog.error = true;
              setTimeout(function() {
                this.dialog.create = true;
              }.bind(this), 3000);
              console.error("EXCEPTION "+JSON.stringify(res));
            }
          })
          .catch(error => {
            this.dialog.error = true;
              setTimeout(function() {
                this.dialog.create = true;
              }.bind(this), 3000);
            console.error("EXCEPTION "+error);
          });
      },
      
    }
}
</script>

<style>

</style>